import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Card, Col, Row, Skeleton, Typography } from "antd";
import { api } from "../services/api";
import { resolveProductImage } from "../utils/productAssets";

const { Title, Text } = Typography;

const sectionStyle = { background: "#fff", padding: "48px 16px" };

function CategoryCard({ category }) {
  return (
    <Link
      to={`/all-products?categorySlug=${encodeURIComponent(category.slug)}`}
      style={{
        display: "flex",
        minHeight: 154,
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "space-between",
        gap: 10,
        padding: "16px 10px 14px",
        borderRadius: 14,
        background: "#fff",
        border: "1px solid #e6edf7",
        textDecoration: "none",
        boxShadow: "0 6px 20px rgba(15, 23, 42, 0.04)",
        transition: "transform 0.2s ease, border-color 0.2s ease, box-shadow 0.2s ease",
      }}
    >
      <div
        style={{
          width: 72,
          height: 72,
          borderRadius: 18,
          background: "#f6faff",
          border: "1px solid #e2edf9",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          padding: 8,
        }}
      >
        <img
          src={resolveProductImage(category.image)}
          alt={category.name}
          style={{ width: "100%", height: "100%", objectFit: "contain" }}
        />
      </div>
      <span
        style={{
          minHeight: 34,
          fontSize: 12,
          fontWeight: 800,
          color: "#1f2937",
          textAlign: "center",
          lineHeight: 1.35,
          display: "-webkit-box",
          WebkitLineClamp: 2,
          WebkitBoxOrient: "vertical",
          overflow: "hidden",
        }}
      >
        {category.name}
      </span>
      <span style={{ fontSize: 10.5, fontWeight: 900, color: "#3991D5" }}>
        {category.count || 0} item{Number(category.count || 0) === 1 ? "" : "s"}
      </span>
    </Link>
  );
}

function Categories() {
  const [categories, setCategories] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let mounted = true;
    setLoading(true);

    api.get("/categories")
      .then((data) => {
        if (mounted) setCategories(data.categories || []);
      })
      .catch(() => {
        if (mounted) setCategories([]);
      })
      .finally(() => {
        if (mounted) setLoading(false);
      });

    return () => {
      mounted = false;
    };
  }, []);

  return (
    <section style={sectionStyle}>
      <div className="container">
        <Card
          bordered={false}
          style={{
            background: "#fff",
            borderRadius: 20,
            boxShadow: "0 4px 32px rgba(30,80,200,0.07)",
            padding: "8px 16px",
          }}
        >
          <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", gap: 16, marginBottom: 32, flexWrap: "wrap" }}>
            <div>
              <Title level={2} style={{ color: "#1a56db", marginBottom: 4, fontWeight: 800, fontFamily: "Gopher" }}>
                Shop By Categories
              </Title>
              <Text style={{ color: "#64748b", fontWeight: 600 }}>
                Browse machine parts by product family, brand line, and subcategory.
              </Text>
            </div>
            <Link
              to="/categories"
              style={{
                border: "1px solid #cfe2f7",
                borderRadius: 999,
                color: "#1a6db5",
                fontSize: 13,
                fontWeight: 900,
                padding: "9px 16px",
                whiteSpace: "nowrap",
                textDecoration: "none",
              }}
            >
              View all categories
            </Link>
          </div>

          {loading ? (
            <Row gutter={[16, 16]} justify="center">
              {Array.from({ length: 12 }).map((_, index) => (
                <Col key={index} xs={12} sm={8} md={6} lg={4}>
                  <Skeleton.Node active style={{ width: "100%", height: 154, borderRadius: 14 }} />
                </Col>
              ))}
            </Row>
          ) : categories.length ? (
            <Row gutter={[16, 16]} justify="center">
              {categories.slice(0, 12).map((cat) => (
                <Col key={cat.slug || cat.name} xs={12} sm={8} md={6} lg={4}>
                  <CategoryCard category={cat} />
                </Col>
              ))}
            </Row>
          ) : (
            <div style={{ padding: "32px 12px", textAlign: "center", color: "#64748b", fontWeight: 700 }}>
              Categories will appear here after they are added in the dashboard.
            </div>
          )}
        </Card>
      </div>
    </section>
  );
}

export default Categories;
